import React, { memo } from 'react';
import * as S from './styled';
export const EmptyState = memo(({ searchValue }) => (React.createElement(S.Container, null,
    React.createElement(S.Content, null,
        React.createElement("span", null,
            "No results found for",
            ` `),
        React.createElement("span", null,
            "'",
            React.createElement("strong", null, searchValue),
            "'.")))));
